import { Y42FeatureType } from '@y42/json-schema';
import { FeatureRecord } from '../models/abstract-feature-entity-state.model';
import { Y42Routes } from './y42-router.model';

export const Y42FeatureTypeToRoute = {
  [Y42FeatureType.Integration]: Y42Routes.Integration,
  [Y42FeatureType.UiModel]: Y42Routes.UiModeling,
  [Y42FeatureType.SqlModel]: Y42Routes.SqlModeling,
  [Y42FeatureType.Orchestration]: Y42Routes.Orchestration,
  [Y42FeatureType.VisualizationDashboard]: Y42Routes.VisualizationDashboard,
  [Y42FeatureType.VisualizationWidget]: Y42Routes.VisualizationWidget,
  [Y42FeatureType.VisualizationFilter]: Y42Routes.VisualizationFilter,
  [Y42FeatureType.VisualizationTheme]: Y42Routes.VisualizationTheme,
  [Y42FeatureType.Export]: Y42Routes.Export,
  [Y42FeatureType.StatusAlert]: Y42Routes.AlertStatusAlert,
  [Y42FeatureType.Lineage]: Y42Routes.Lineage,
  [Y42FeatureType.Catalog]: Y42Routes.Catalog,
} as const;

// This allows us to define the mapping `as const` and still adhere to a specific type
const __Y42FeatureTypeToRoute__TYPE_TEST: FeatureRecord<Y42Routes> = Y42FeatureTypeToRoute;

export const Y42RouteToFeatureType = {
  [Y42Routes.Integration]: Y42FeatureType.Integration,
  [Y42Routes.Modeling]: Y42FeatureType.UiModel,
  [Y42Routes.UiModeling]: Y42FeatureType.UiModel,
  [Y42Routes.SqlModeling]: Y42FeatureType.SqlModel,
  [Y42Routes.Orchestration]: Y42FeatureType.Orchestration,
  [Y42Routes.Visualization]: Y42FeatureType.VisualizationDashboard,
  [Y42Routes.VisualizationDashboard]: Y42FeatureType.VisualizationDashboard,
  [Y42Routes.VisualizationWidget]: Y42FeatureType.VisualizationWidget,
  [Y42Routes.VisualizationFilter]: Y42FeatureType.VisualizationFilter,
  [Y42Routes.VisualizationTheme]: Y42FeatureType.VisualizationTheme,
  [Y42Routes.Export]: Y42FeatureType.Export,
  [Y42Routes.Alert]: Y42FeatureType.StatusAlert,
  [Y42Routes.AlertStatusAlert]: Y42FeatureType.StatusAlert,
  [Y42Routes.Lineage]: Y42FeatureType.Lineage,
  [Y42Routes.Profile]: null,
  [Y42Routes.Catalog]: Y42FeatureType.Catalog,
  [Y42Routes.Editor]: null,
} as const;

// This allows us to define the mapping `as const` and still be type-safe/adhere to a specific type
const __Y42RouteToFeatureType__TYPE_TEST: Record<Y42Routes, Y42FeatureType | null> = Y42RouteToFeatureType;
